/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable max-len */
import { HttpErrorResponse } from '@angular/common/http';

/**
 * Example:
 * {
    "error": {
        "message": "Validation failed: Roof construction year must be greater than or equal to 2025",
        "errors": {
            "roof_construction_year": [
                "must be greater than or equal to 2025"
            ]
        },
        "context": {
            "roof_construction_year": 2023,
            "year_built": 2025
        }
    }
}
 */
export interface ApiValidationError {
  message: string;
  errors: Record<string, string[]>;
  context: Record<string, any>;
}

export function isApiValidationError(obj: any): obj is ApiValidationError {
  return !!obj && typeof obj === 'object' && typeof obj.message === 'string' && !!obj.errors && typeof obj.errors === 'object' && !!obj.context && typeof obj.context === 'object';
}

export function mapUserFriendlyErrorMessage(httpErrorResponse: HttpErrorResponse): string {
  if (httpErrorResponse.status === 422) {
    return mapValidationError(httpErrorResponse);
  }

  return 'There was a problem processing your information. Please double check what was entered and try again or contact support.';
}

export function mapValidationError(httpErrorResponse: HttpErrorResponse): string {
  if (!isApiValidationError(httpErrorResponse.error.error)) {
    return 'There was a problem processing your information. Please double check what was entered and try again or contact support.';
  }

  const validationError = httpErrorResponse.error.error;

  if (validationError.errors['roof_construction_year'] && validationError.context && validationError.context['roof_construction_year'] && validationError.context['year_built']) {
    const roofConstructionYearValue = validationError.context['roof_construction_year'];
    const homeConstructionYearValue = validationError.context['year_built'];
    return `You've entered a home construction year of ${homeConstructionYearValue} which is later than the roof construction year of your home that we have on file (${roofConstructionYearValue}). Please update the home construction year to be ${roofConstructionYearValue} or earlier. If you believe our information about your roof is incorrect, please call us to speak with an agent.`;
  }

  return 'There was a problem processing your information. Please double check what was entered and try again or contact support.';
}
